<template>
  <g>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M16.67 13.1302C18.04 14.0602 19 15.3202 19 17.0002V20.0002H22C22.55 20.0002 23 19.5502 23 19.0002V17.0002C23 14.8202 19.43 13.5302 16.67 13.1302Z"
    />
    <path
      d="M9 12.0002C11.2091 12.0002 13 10.2094 13 8.00024C13 5.79111 11.2091 4.00024 9 4.00024C6.79086 4.00024 5 5.79111 5 8.00024C5 10.2094 6.79086 12.0002 9 12.0002Z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M15 12.0002C17.21 12.0002 19 10.2102 19 8.00024C19 5.79024 17.21 4.00024 15 4.00024C14.53 4.00024 14.09 4.10024 13.67 4.24024C14.5 5.27024 15 6.58024 15 8.00024C15 9.42024 14.5 10.7302 13.67 11.7602C14.09 11.9002 14.53 12.0002 15 12.0002Z"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9 13.0002C6.33 13.0002 1 14.3402 1 17.0002V19.0002C1 19.5502 1.45 20.0002 2 20.0002H16C16.55 20.0002 17 19.5502 17 19.0002V17.0002C17 14.3402 11.67 13.0002 9 13.0002Z"
    />
  </g>
</template>
